
/*============ Header Function Start ============*/
 
 

jQuery(document).ready(function(){
	jQuery(".serach-icon a").click(function(){
		jQuery(".search-outer").slideToggle(300);
	});
  	jQuery(".search-close a").click(function(){
		jQuery(".search-outer").slideToggle(300);
	});

  jQuery('select').niceSelect();

  jQuery(".menu-btn").click(function(){
    jQuery("body").addClass("open-nav");
		jQuery(".header-bottom-outer").addClass("active");
	});
   jQuery(".header-bottom-outer .close-nav").click(function(){
    jQuery("body").removeClass("open-nav");
		jQuery(".header-bottom-outer").removeClass("active");
	});
   

});

jQuery(function () {
    jQuery('.sidebar-title h5').click(function () {
        const $block = jQuery(this).parents(".sidebar-block");

        if ($block.hasClass("active")) {
            $block.removeClass("active");
            $block.find(".sidebar-block-inner").stop(true, true).slideUp(300);
        } else {
            jQuery(".sidebar-block").removeClass("active");
            jQuery(".sidebar-block-inner").stop(true, true).slideUp(300);

            $block.addClass("active");
            $block.find(".sidebar-block-inner").stop(true, true).slideDown(300);
        }
    });
});
/*============ Header Function End ============*/

/*============ Slick-Slider Function Start ============*/
 

jQuery(document).ready(function(){
	
	
   if(jQuery(".slider-for").length > 0){
    jQuery('.slider-for').slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: '.slider-nav'
    });
   }
  	
   if(jQuery(".slider-nav").length > 0){
    jQuery('.slider-nav').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: '.slider-for',
      dots: false,
      focusOnSelect: true
    });
   }

	
});

	  
/*============ Slick-Slider Function End ============*/



// $(document).ready(function () {
//   $('.qty-btn.plus').click(function () {
//     let input = $(this).siblings('.qty-input');
//     let current = parseInt(input.val());
//     input.val(current + 1);
//   });

//   $('.qty-btn.minus').click(function () {
//     let input = $(this).siblings('.qty-input');
//     let current = parseInt(input.val());
//     let min = parseInt(input.attr('min')) || 1;
//     if (current > min) {
//       input.val(current - 1);
//     }
//   });
// });


// $(document).ready(function() {
//     $('.tab').click(function() {
//       var tabId = $(this).data('tab');

//       $('.tab').removeClass('active');
//       $(this).addClass('active');

//       $('.tab-content').removeClass('active');
//       $('.tab-content[data-content="' + tabId + '"]').addClass('active');
//     });
//   });


  